// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEND = "Ode\u0161li";
export const SEO_TITLE_FAQ_ASK_QUESTION = "Napi\u0161 n\u00e1m";
